export default {
  label: {
    SENT: 'Enviadas',
    RECEIVED: 'Recibidas',
    ACCEPTED: 'Aceptadas',
    REJECTED: 'Rechazadas',
    1: 'Sin emitir',
    2: 'Pendiente de emisión',
    3: 'Pendiente de leer',
    4: 'Error de emisión',
    5: 'Leída',
    6: 'Aceptada',
    7: 'Rechazada',
    8: 'Cobro externo',
    9: 'Emitido cobro',
    10: 'Pago externo',
    11: 'Emitido pago',
    12: 'Cobrada',
    13: 'Pagada',
    14: 'Rectificada',
    15: 'Notificada',
    16: 'Descargada automáticamente',
    17: 'Enviada a plataforma externa',
    18: 'Aceptada por plataforma externa',
    19: 'Rechazada por palatorma externa',
    20: 'Pro forma enviada',
    21: 'Pro forma leída',
    22: 'Pro forma aceptada',
    23: 'Pro forma enviada',
    29: 'Pro forma rechazada',
    30: 'En custodia',
    31: 'Registrada',
    32: 'En trámite de autorización',
    33: 'En trámite de pago',
    34: 'Gestión de incidencia',
    35: 'Registrada en el RCF',
    36: 'Contabilizada',
    37: 'Devuelto el pago',
    38: 'Anulada',
    39: 'Solicitada anulación',
    40: 'Aceptada anulación',
    41: 'Rechazada anulación'
  }
}
